import { UUID } from "crypto";

/**
 * Query keys factory for pre-orders
 * Centralized key management for all pre-order related queries
 */
export const preOrderKeys = {
  all: ["pre-orders"] as const,
  lists: () => [...preOrderKeys.all, "list"] as const,
  list: (page: number = 1, size: number = 1000) =>
    [...preOrderKeys.lists(), page, size] as const,
  byDate: (date: string) => [...preOrderKeys.all, "date", date] as const,
  recap: (date: string) => [...preOrderKeys.all, "recap", date] as const,
  byChat: (chatId: string) => [...preOrderKeys.all, "chat", chatId] as const,
  bySMSChat: (chatId: string) =>
    [...preOrderKeys.all, "sms-chat", chatId] as const,
  byEmail: () => [...preOrderKeys.all, "email"] as const,
  byEmailId: (emailId: string) =>
    [...preOrderKeys.all, "email", emailId] as const,
  // V2 fetch keys (separate from legacy "chat"/"email" keys so cache entries do not collide).
  v2ByWhatsAppChat: (chatId: string) =>
    [...preOrderKeys.all, "v2", "whatsapp-chat", chatId] as const,
  v2BySMSChat: (chatId: string) =>
    [...preOrderKeys.all, "v2", "sms-chat", chatId] as const,
  v2ByEmail: (emailId: string) =>
    [...preOrderKeys.all, "v2", "email", emailId] as const,
  byOrder: (orderId: UUID) => [...preOrderKeys.all, "order", orderId] as const,
  detail: (id: UUID) => [...preOrderKeys.all, "detail", id] as const,
  flows: (preOrderId: string) =>
    [...preOrderKeys.all, "flows", preOrderId] as const,
  history: (preOrderId: string) =>
    [...preOrderKeys.all, "history", preOrderId] as const,
} as const;
